import { Array, pipe } from 'effect'
import { isNotUndefined } from 'effect/Predicate'

/**
 * view の画面のタブに並ぶ view（tabViews）と、画面に出す view（shownView）。エージェントの会話の対象も shownView で決めるので、
 * 画面に出す view の決め方はここだけに置く。左の一覧の view（siderViews）は、redux から Apollo cache に移す予定（salescore-inc/dev&75）なので、
 * どこから読むかは呼び出し側に任せて引数で受ける
 */
export const viewTabsOf = <View extends { readonly id: string }>({
  siderViews,
  pickedViewId,
  pickedViewIds,
  defaultOpenViewIds,
}: {
  siderViews: readonly View[]
  pickedViewId: string | undefined
  pickedViewIds: readonly string[]
  defaultOpenViewIds: readonly string[]
}): { tabViews: View[]; shownView: View | undefined } => {
  const tabViews = pipe(
    // 選んだ view は基本的に開いた view に入っているが、選んだ直後は入っていない（ViewLayout の useEffect で入る）
    [...defaultOpenViewIds, ...pickedViewIds, pickedViewId],
    Array.dedupe,
    Array.map((id) => siderViews.find((view) => view.id === id)),
    Array.filter(isNotUndefined),
  )
  // 選んだ view が左の一覧になければ（まだ選んでいない、消した view の id が localStorage に残っている）、タブの先頭を出す
  return { tabViews, shownView: siderViews.find((view) => view.id === pickedViewId) ?? tabViews[0] }
}
